import React from 'react';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { LINE_ITEM_30MIN_DEPOSITE, propTypes } from '../../util/types';
import { types as sdkTypes } from '../../util/sdkLoader';

import css from './OrderBreakdown.module.css';

const { Money } = sdkTypes;

const LineItemDepositedAmount = props => {
  const { lineItems, code, intl } = props;

  // Find correct line-item for given code prop.
  // It should be one of the following: 'line-item/night, 'line-item/day', 'line-item/hour', or 'line-item/item'
  // These are defined in '../../util/types';
  const unitPurchase = lineItems.find(item => item.code === code && !item.reversal);
  const isDepositeAmount = lineItems.find(item => item.code === LINE_ITEM_30MIN_DEPOSITE);
  const lineTotal = isDepositeAmount ? isDepositeAmount.lineTotal : new Money(-(unitPurchase?.lineTotal?.amount/2), unitPurchase?.lineTotal?.currency);
  const total = unitPurchase ? formatMoney(intl, lineTotal) : null;

  return total ? (
    <div className={css.lineItem}>
      <span className={css.itemLabelPaid}>
        <FormattedMessage id={'LineItemDepositedAmount.depositeMoneyLabel'} />
      </span>
      <span className={css.itemValuePaid}>{total}</span>
    </div>
  ) : null;
};

LineItemDepositedAmount.propTypes = {
  lineItems: propTypes.lineItems.isRequired,
  code: propTypes.lineItemUnitType.isRequired,
  intl: intlShape.isRequired,
};

export default LineItemDepositedAmount;